// extracted by mini-css-extract-plugin
module.exports = {"topImage":"topImage--3KeAU","content":"content--1xfuC","regions":"regions--6jOnB"};